var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-group"},[_c('a-textarea',{attrs:{"defaultValue":_vm.defaultValue,"auto-size":{ minRows: 3, maxRows: 10 }},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }